import React from "react";
import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
  current: number;
  max: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, max }) => {
  // Prevent division by zero
  const percentage = max > 0 ? (current / max) * 100 : 0;

  // Ensure at least a visible sliver (5%) when at 0%
  const visualPercentage = current > 0 ? percentage : 5;

  // Clamp between 0 and 100
  const safePercentage = Math.min(Math.max(visualPercentage, 0), 100);

  return (
    <div className={styles.progressContainer}>
      <div
        className={styles.progressBar}
        style={{ width: `${safePercentage}%` }}
      />
    </div>
  );
};

export default ProgressBar;
